//React Components and Hooks
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
//Images
import logo from "../../assets/images/logo-dark.png";
import VersionDisplay from "../../layout-components/SidebarFooter/VersionDisplay";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" to="/">
        American Power & Light LLC
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage:
      "url(https://borror.com/wp-content/uploads/2017/08/downtown-columbus-ohio.jpg)",
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(24, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const HomePage = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <CssBaseline />
      <Box sx={{ 
        display: { xs: 'none', sm: 'block' },
        flex: { sm: '4 1 33.33%', md: '7 1 58.33%' }
      }} className={classes.image} />
      <Box sx={{ 
        flex: { xs: '1 1 100%', sm: '8 1 66.67%', md: '5 1 41.67%' },
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Paper elevation={6} square sx={{ height: '100%' }}>
          <div className={classes.paper}>
            <img src={logo} alt="apl" />
            <Typography component="h3" variant="h3">
              Ubil+
            </Typography>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={() => navigate("/login")}
            >
              Sign In
            </Button>

            {/* <Button
                type="submit"
                variant="contained"
                color="secondary"
                className={classes.submit}
              >
                Register
              </Button> */}
            <VersionDisplay />
            <Box mt={5}>
              <Copyright />
            </Box>
          </div>
        </Paper>
      </Box>
    </Box>
  );
};

export default HomePage;
